import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const ProductHistory = lazy(() => import('components/productModule/productVersion/ProductHistory'));

const ProductHistoryPage = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<ProductHistory />
			</Suspense>
		</div>
	);
};

export default ProductHistoryPage;
